<template>
	<div class="password-input-container">
		<SignupTextField
			:label="label"
			v-on="$listeners"
			iconName="input-key"
			:v-model="password"
			:placeholder="placeholder"
			data-cy="registration-password"
			:rules="passwordValidationRules"
			:type="showContent ? 'text' : 'password'"
			@click:append="showContent = !showContent"
			:append-icon="showContent ? 'mdi-eye' : 'mdi-eye-off'"
		/>
	</div>
</template>

<script>
import SignupTextField from './SignupTextField';
import UserRegistrationService from '@/views/userRegistration/helpers/UserRegistrationService';

export default {
	name: 'PasswordTextField',
	components: {
		SignupTextField,
	},
	props: {
		label: { type: String },
		password: { type: String },
		placeholder: { type: String, default: 'Password (at least 8 characters)' },
	},
	methods: {
		isRuleValid(validationFunc) {
			return validationFunc(this.password || '') === true;
		},
	},
	computed: {
		isPasswordValid() {
			return this.passwordValidationFuncs.every((validationFunc) => this.isRuleValid(validationFunc));
		},
	},
	data: () => ({
		showContent: false,
		passwordValidationFuncs: UserRegistrationService.getPasswordValidationFuncs(),
		passwordValidationRules: UserRegistrationService.getPasswordValidationRules(),
	}),
	watch: {
		isPasswordValid: {
			handler(newV) {
				this.$emit('password-valid-update', newV);
			},
		},
	},
};
</script>

<style scoped lang="scss">
.password-input-container {
	display: flex;
	flex-direction: column;

	.password-requierments-container {
		display: flex;
		flex-wrap: wrap;
		margin-top: -30px;
		margin-bottom: 25px;

		.requierment-row {
			height: 30px;
			min-width: 200px;

			.indication-icon {
				width: 14px;
				height: 14px;
			}

			.error-text {
				font-size: 12px;
				text-align: left;
				padding-left: 7px;
				color: var(--primary-error-font-color);
			}

			.success-text {
				font-size: 12px;
				text-align: left;
				padding-left: 7px;
				text-decoration: line-through;
				color: var(--primary-success-font-color);
			}
		}
	}
}
</style>
